import {Brick, registerBrick, ErrorFlow} from 'olympe';

export default class EndOfSendAttachmentAPIManager extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {[]} accumulator
     * @param {function()} forwardEvent
     * @param {function([])} setErrors
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [accumulator], [forwardEvent, setErrors, setErrorFlow]) {
        const messages = [];

        accumulator.map((e) => {
            if (e instanceof ErrorFlow) {
                messages.push({
                    errorCode: e.getCode(),
                    errorMessage: e.getMessage(),
                });
            }
        });

        setErrors(messages);
        if (messages.length > 0) {
            setErrorFlow(ErrorFlow.create('Error in Send Attachment API', 1));
        } else {
            forwardEvent();
        }
    }
}

registerBrick('018848ed1b85f01ae76f', EndOfSendAttachmentAPIManager);
